var React = require('react');

function Nr (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M-54.7 0H628v512H-54.7z"}))),React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt","clipPath":"url(#a)","transform":"translate(51.3) scale(.9375)","key":1},[React.createElement("path",{"fill":"#002170","d":"M-140 0H884v512H-140z","key":0}),React.createElement("path",{"fill":"#ffb20d","d":"M-140 234.1H884V278H-140z","key":1}),React.createElement("path",{"fill":"#fff","d":"M161.8 438l-33-33-10.5 45.4-12-45-31.9 34 12.1-45L42 407.9l33-33-45.4-10.6 45-12-34-31.8 45 12L72 288l33 33 10.6-45.4 12 45 31.8-34-12 45 44.5-13.5-33 33 45.4 10.5-45 12 34 32-45-12.2z","key":2})])]);
}

Nr.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Nr;

Nr.default = Nr;
